import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/vercel/path0/app/layout-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageComponent"] */ "/vercel/path0/app/termine/[eventId]/component.tsx");
